import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { fetchWooProducts } from "../../../api/wooService";

const ITEMS_PER_PAGE = 6;

const ShopPage = () => {
  const { t } = useTranslation();
  const [allProducts, setAllProducts] = useState([]);
  const [visibleProducts, setVisibleProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nextIndex, setNextIndex] = useState(0);
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  useEffect(() => {
    const loadProducts = async () => {
      const data = await fetchWooProducts([60], { status: "publish" });

      // Sort: featured products first
      	const featured = data.filter((item) => item.featured);
		const nonFeatured = data
		  .filter((item) => !item.featured)
		  .filter((item) => item.date_created) // ensure date exists
		  .sort((a, b) => {
			const dateA = new Date(a.date_created);
			const dateB = new Date(b.date_created);
			return dateB - dateA; // Newest first
		  });

		const sorted = [...featured, ...nonFeatured];

      setAllProducts(sorted);
      setVisibleProducts(sorted.slice(0, ITEMS_PER_PAGE));
      setNextIndex(ITEMS_PER_PAGE);
      setLoading(false);
    };

    loadProducts();
  }, []);

  const loadMore = useCallback(() => {
    if (isFetchingMore || nextIndex >= allProducts.length) return;

    setIsFetchingMore(true);
    const nextBatch = allProducts.slice(nextIndex, nextIndex + ITEMS_PER_PAGE);
    setVisibleProducts((prev) => [...prev, ...nextBatch]);
    setNextIndex((prev) => prev + ITEMS_PER_PAGE);
    setIsFetchingMore(false);
  }, [isFetchingMore, nextIndex, allProducts]);

  useEffect(() => {
    const handleScroll = () => {
      const nearBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 300;

      if (nearBottom && !isFetchingMore) {
        loadMore();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loadMore, isFetchingMore]);

  return (
    <div className="container mt-5 mt-xl-10">
      {loading ? (
        <h4 style={{ fontWeight: "bold", lineHeight: "90%" }}>
          {t("global.loading")}
        </h4>
      ) : (
        <>
          <div className="row g-4">
            {visibleProducts.map((product) => (
              <div key={product.id} className="col-md-6 col-lg-4">
                <div className="product h-100 d-flex flex-column">
                  <figure className="product-image mb-3">
                    <a href={`/officina/${product.slug}`} className="d-block">
                      <img
                        src={product.images?.[0]?.src || "/placeholder.jpg"}
                        alt={product.name}
                        className="img-fluid"
                      />
                    </a>
                  </figure>
                  <a
                    className="product-title mb-1 text-decoration-none text-dark fw-semibold"
                    href={`/officina/${product.slug}`}
                    style={{
                      fontWeight: "bold",
                      lineHeight: "90%",
                      textTransform: "uppercase",
                    }}
                  >
                    {product.name}
                  </a>
                  {product.stock_status === "instock" && (
                    <span
                      className="product-price text-dark fw-semibold"
                      dangerouslySetInnerHTML={{ __html: product.price_html }}
                      style={{ lineHeight: "90%" }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>

          {isFetchingMore && (
            <div className="text-center mt-4">
              <span className="text-muted">{t("global.loading", "Loading...")}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ShopPage;
